import {useEffect, useState} from 'react'
import "./Conditions.css"
import { getLegalNotices } from '../../HTTP/user';
const Legales = () => {
  const [legal, setLegal] = useState(null); // string html
  
    useEffect(() => {
      const fetchLegal = async () => {
        try {
          const res = await getLegalNotices();
          if (res) {
            setLegal(res.value);
          }
        }  catch (error) {
          console.error("Erreur lors de la récupération des CGU :", error);
        }
      }
      fetchLegal();
    }, []);
  
    return (
      <div className='mt-8 py-12 px-4 sm:px-6 lg:px-8 md:max-h-screen md:overflow-y-auto'>
        <div dangerouslySetInnerHTML={{ __html: legal }}></div>
      </div>
    )
}

export default Legales